module.exports = __webpack_public_path__ + "static/media/report-cutlery-icon.6b8df414.svg";